import React, { FC, useEffect, useRef, useState } from 'react'
import classnames from 'classnames'
import { useAppSelector } from 'hooks/redux'
import useAsideBarContext from 'contexts/AsideBar.context'
import { AsideBarOption } from './types'
import AsideBarOptionsItem from './AsideBarOptionsItem'

import cl from './style.module.scss'

interface AsideBarListProps {
	asideBarOptionsList: AsideBarOption[]
}

const AsideBarOptions: FC<AsideBarListProps> = ({ asideBarOptionsList }) => {
	const { asideIsOpen } = useAsideBarContext()
	const { isFinalTestOngoing } = useAppSelector((state) => state.test)

	const asideStyles = classnames(cl.container, {
		[cl.open]: asideIsOpen,
		[cl.hide]: isFinalTestOngoing
	})

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [isFinalTestOngoing])

	return (
		<aside className={asideStyles}>
			<ul className={cl.options}>
				{asideBarOptionsList.map((asideBarOptionsListItem) => (
					<AsideBarOptionsItem
						key={asideBarOptionsListItem.id}
						{...asideBarOptionsListItem}
					/>
				))}
			</ul>
		</aside>
	)
}

export default AsideBarOptions
